import Vue from 'vue'
import VueRouter from 'vue-router'
import MasterDetail from "./components/pages/MasterDetail.vue"
import MultiGrid from "./components/pages/MultiGrid.vue"
import ThreeGrids from "./components/pages/ThreeGrids.vue"
import TotalGrid from "./components/pages/TotalGrid.vue"
import DnDGrid from "./components/pages/DnDGrid.vue"
import FrontPaging from "./components/pages/FrontPaging.vue"
import DBPaging from "./components/pages/DBPaging.vue"
import ManyColumns from "./components/pages/ManyColumns.vue"
import PersonalizeGrid from "./components/pages/PersonalizeGrid.vue"
import ContextMenu from "./components/pages/ContextMenu.vue"
import MergeGrid from "./components/pages/MergeGrid.vue"
import ImportExport from "./components/pages/ImportExport.vue"
import ExampleCode from "./components/pages/ExampleCode.vue"

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "MasterDetail",
        meta: {
            reload: true,
        },
        component: MasterDetail
    },
    {
        path: "/MasterDetail",
        name: "MasterDetail",
        component: MasterDetail
    },
    {
        path: "/MultiGrid",
        name: "MultiGrid",
        component: MultiGrid
    },
    {
        path: "/ThreeGrids",
        name: "ThreeGrids",
        component: ThreeGrids
    },
    {
        path: "/TotalGrid",
        name: "TotalGrid",
        component: TotalGrid
    },
    {
        path: "/DnDGrid",
        name: "DnDGrid",
        component: DnDGrid
    },
    {
        path: "/FrontPaging",
        name: "FrontPaging",
        component: FrontPaging
    },
    {
        path: "/DBPaging",
        name: "DBPaging",
        component: DBPaging
    },
    {
        path: "/ManyColumns",
        name: "ManyColumns",
        component: ManyColumns
    },
    {
        path: "/PersonalizeGrid",
        name: "PersonalizeGrid",
        component: PersonalizeGrid
    },
    {
        path: "/ContextMenu",
        name: "ContextMenu",
        component: ContextMenu
    },
    {
        path: "/MergeGrid",
        name: "MergeGrid",
        component: MergeGrid
    },
    {
        path: "/ImportExport",
        name: "ImportExport",
        component: ImportExport
    },
    {
        path: "/ExampleCode",
        name: "ExampleCode",
        component: ExampleCode
    },
];

const router = new VueRouter({
    history: 'history',
    routes,
})

export default router;